import { inject } from 'vue'

export function requiredInject<T>(key: string): T {
  const injected = inject<T>(key)
  if (!injected) {
    throw new Error(`Injection for "${key}" is missing.`)
  }
  return injected
}
